/**
 * Lớp vỏ ESM của `roles.cjs` — mọi định nghĩa nằm ở file .cjs bên cạnh.
 *
 * Vì sao tách đôi: luật "role bị khoá vùng" có một bất biến chống vòng lặp redirect
 * (`home` phải nằm trong chính `prefix` của nó) cần test canh, mà `node --test` chỉ
 * require được CommonJS. Giữ file .js này để mọi nơi vẫn `import { ... } from
 * "@/constants/roles"` như cũ, không phải sửa 7 chỗ import và không sinh bản sao thứ
 * hai của danh sách role.
 */
import roles from "./roles.cjs";

export const ROLE_ADMIN = roles.ROLE_ADMIN;
export const ROLE_STAFF = roles.ROLE_STAFF;
export const ROLE_PRINTER = roles.ROLE_PRINTER;
export const ROLE_ACCOUNTANT = roles.ROLE_ACCOUNTANT;
export const ROLE_FOREMAN = roles.ROLE_FOREMAN;
export const ROLE_SECRETARY = roles.ROLE_SECRETARY;
export const ROLE_SUPER_ADMIN = roles.ROLE_SUPER_ADMIN;
export const ROLE_SHIPPING_CLERK = roles.ROLE_SHIPPING_CLERK;

export const ROLE_LABELS = roles.ROLE_LABELS;
export const roleLabel = roles.roleLabel;

export const ADMIN_ROLES = roles.ADMIN_ROLES;
export const BUSINESS_ROLES = roles.BUSINESS_ROLES;
export const SALES_ROLES = roles.SALES_ROLES;
export const SHIPPING_LABEL_ROLES = roles.SHIPPING_LABEL_ROLES;
export const ORDER_MONEY_ROLES = roles.ORDER_MONEY_ROLES;
export const INVOICE_ROLES = roles.INVOICE_ROLES;
export const ACCOUNTING_ROLES = roles.ACCOUNTING_ROLES;
export const RECEIVABLE_ROLES = roles.RECEIVABLE_ROLES;
export const RECEIVABLE_GROUP_MENU_ROLES = roles.RECEIVABLE_GROUP_MENU_ROLES;
export const DELIVERY_SCHEDULE_ROLES = roles.DELIVERY_SCHEDULE_ROLES;
export const PARTNER_DEBT_ROLES = roles.PARTNER_DEBT_ROLES;
export const AUDIT_LOG_ROLES = roles.AUDIT_LOG_ROLES;
export const PRIVATE_DEBT_ROLES = roles.PRIVATE_DEBT_ROLES;
export const ORDER_BULK_ACTION_ROLES = roles.ORDER_BULK_ACTION_ROLES;
export const ORDER_BULK_SHIP_ROLES = roles.ORDER_BULK_SHIP_ROLES;
export const PRICE_WRITE_ROLES = roles.PRICE_WRITE_ROLES;
export const ORDER_ITEM_PRICE_WRITE_ROLES = roles.ORDER_ITEM_PRICE_WRITE_ROLES;
export const PAYMENT_WRITE_ROLES = roles.PAYMENT_WRITE_ROLES;
export const COD_WRITE_ROLES = roles.COD_WRITE_ROLES;
export const FREESHIP_WRITE_ROLES = roles.FREESHIP_WRITE_ROLES;

export const CONFINED_ROLE_AREAS = roles.CONFINED_ROLE_AREAS;
export const SHARED_ROUTE_PREFIXES = roles.SHARED_ROUTE_PREFIXES;

export const areaPrefixes = roles.areaPrefixes;
export const isSharedRoute = roles.isSharedRoute;
export const confinedRedirect = roles.confinedRedirect;
export const confinesOnPublicRoutes = roles.confinesOnPublicRoutes;
export const roleAllowed = roles.roleAllowed;
export const isAdminRole = roles.isAdminRole;
